var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    [
      _c(
        "basic-container",
        [
          _c(
            "el-tabs",
            {
              attrs: { value: _vm.currentTab },
              on: { "tab-click": _vm.handleTabClick },
            },
            [
              _c("el-tab-pane", {
                attrs: { label: "线上数据", name: "online" },
              }),
              _c("el-tab-pane", {
                attrs: { label: "本地数据", name: "local" },
              }),
            ],
            1
          ),
          _c("div", { staticClass: "search-contain" }, [
            _c(
              "div",
              { staticClass: "search-left" },
              [
                _c("el-input", {
                  staticStyle: { width: "200px" },
                  attrs: { placeholder: "请输入策略名称", clearable: "" },
                  model: {
                    value: _vm.searchParams.name,
                    callback: function ($$v) {
                      _vm.$set(_vm.searchParams, "name", $$v)
                    },
                    expression: "searchParams.name",
                  },
                }),
                _c("DynamicOption", {
                  staticStyle: { "margin-left": "20px" },
                  attrs: {
                    placeholder: "请选择收端渠道",
                    singleSelect: true,
                    params: _vm.searchOptions,
                  },
                  model: {
                    value: _vm.searchParams.channelId,
                    callback: function ($$v) {
                      _vm.$set(_vm.searchParams, "channelId", $$v)
                    },
                    expression: "searchParams.channelId",
                  },
                }),
                _c(
                  "el-select",
                  {
                    staticStyle: { "margin-left": "20px" },
                    attrs: { clearable: "", placeholder: "请选择状态" },
                    model: {
                      value: _vm.searchParams.status,
                      callback: function ($$v) {
                        _vm.$set(_vm.searchParams, "status", $$v)
                      },
                      expression: "searchParams.status",
                    },
                  },
                  [
                    _c("el-option", { attrs: { label: "启用", value: 1 } }),
                    _c("el-option", { attrs: { label: "禁用", value: 0 } }),
                  ],
                  1
                ),
                _vm.currentTab === "local"
                  ? _c(
                      "el-select",
                      {
                        staticStyle: { "margin-left": "20px" },
                        attrs: { clearable: "", placeholder: "请选择审核状态" },
                        model: {
                          value: _vm.searchParams.reviewStatus,
                          callback: function ($$v) {
                            _vm.$set(_vm.searchParams, "reviewStatus", $$v)
                          },
                          expression: "searchParams.reviewStatus",
                        },
                      },
                      [
                        _c("el-option", {
                          attrs: { label: "草稿", value: "1" },
                        }),
                        _c("el-option", {
                          attrs: { label: "待审核", value: "2" },
                        }),
                        _c("el-option", {
                          attrs: { label: "通过", value: "3" },
                        }),
                        _c("el-option", {
                          attrs: { label: "未通过", value: "4" },
                        }),
                      ],
                      1
                    )
                  : _vm._e(),
                _c(
                  "el-select",
                  {
                    staticStyle: { "margin-left": "20px" },
                    attrs: { clearable: "", placeholder: "请选择版本目标类型" },
                    model: {
                      value: _vm.searchParams.versionTargetType,
                      callback: function ($$v) {
                        _vm.$set(_vm.searchParams, "versionTargetType", $$v)
                      },
                      expression: "searchParams.versionTargetType",
                    },
                  },
                  _vm._l(_vm.versionTargetTypeOptions, function (opt) {
                    return _c("el-option", {
                      key: opt.value,
                      attrs: { label: opt.label, value: opt.value },
                    })
                  }),
                  1
                ),
                _c(
                  "el-select",
                  {
                    staticStyle: { "margin-left": "20px" },
                    attrs: { clearable: "", placeholder: "请选择配置端" },
                    model: {
                      value: _vm.searchParams.endType,
                      callback: function ($$v) {
                        _vm.$set(_vm.searchParams, "endType", $$v)
                      },
                      expression: "searchParams.endType",
                    },
                  },
                  _vm._l(_vm.endTypeOptions, function (opt) {
                    return _c("el-option", {
                      key: opt.value,
                      attrs: { label: opt.label, value: opt.value },
                    })
                  }),
                  1
                ),
                _c(
                  "el-popover",
                  {
                    attrs: {
                      placement: "top-start",
                      width: "380",
                      trigger: "hover",
                    },
                  },
                  [
                    _c("div", { staticClass: "priority-tip" }, [
                      _c("p", { staticClass: "priority-tip__title" }, [
                        _vm._v("策略匹配优先级说明"),
                      ]),
                      _c("p", { staticClass: "priority-tip__desc" }, [
                        _vm._v(
                          "\n              一个投屏请求同时符合多条收费策略时，系统只生效优先级最高的一条，从高到低依次匹配：\n            "
                        ),
                      ]),
                      _c("ol", { staticClass: "priority-tip__list" }, [
                        _c("li", [
                          _vm._v("指定发端渠道 ＋ 指定收端渠道 ＋ 指定版本"),
                        ]),
                        _c("li", [
                          _vm._v("指定发端渠道 ＋ 指定收端渠道 ＋ 版本区间"),
                        ]),
                        _c("li", [
                          _vm._v("指定发端渠道 ＋ 全部收端渠道 ＋ 指定版本"),
                        ]),
                        _c("li", [
                          _vm._v("指定发端渠道 ＋ 全部收端渠道 ＋ 版本区间"),
                        ]),
                        _c("li", [
                          _vm._v("指定发端渠道 ＋ 指定收端渠道 ＋ 不限版本"),
                        ]),
                        _c("li", [
                          _vm._v("指定发端渠道 ＋ 全部收端渠道 ＋ 不限版本"),
                        ]),
                        _c("li", [
                          _vm._v("全部发端渠道 ＋ 指定收端渠道 ＋ 指定版本"),
                        ]),
                        _c("li", [
                          _vm._v("全部发端渠道 ＋ 指定收端渠道 ＋ 版本区间"),
                        ]),
                        _c("li", [
                          _vm._v("全部发端渠道 ＋ 全部收端渠道 ＋ 指定版本"),
                        ]),
                        _c("li", [
                          _vm._v("全部发端渠道 ＋ 全部收端渠道 ＋ 版本区间"),
                        ]),
                        _c("li", [
                          _vm._v("全部发端渠道 ＋ 指定收端渠道 ＋ 不限版本"),
                        ]),
                        _c("li", [
                          _vm._v("全部发端渠道 ＋ 全部收端渠道 ＋ 不限版本"),
                        ]),
                      ]),
                      _c("p", { staticClass: "priority-tip__rule" }, [
                        _vm._v(
                          "\n              规则：先看发端渠道（指定优先）→ 再看是否限定版本（限定优先）→ 再看收端渠道（指定优先）→ 最后看版本方式（指定版本优先于版本区间）；同一优先级有多条时取最新配置。\n            "
                        ),
                      ]),
                    ]),
                    _c("i", {
                      staticClass: "el-icon-question",
                      staticStyle: {
                        "margin-left": "20px",
                        color: "#507dc5",
                        cursor: "pointer",
                      },
                      attrs: { slot: "reference" },
                      slot: "reference",
                    }),
                  ]
                ),
              ],
              1
            ),
            _c(
              "div",
              { staticClass: "search-right" },
              [
                _c(
                  "el-button",
                  {
                    directives: [
                      {
                        name: "auth",
                        rawName: "v-auth",
                        value: "SCREEN_CHARGE_MANAGE_SEARCH",
                        expression: "'SCREEN_CHARGE_MANAGE_SEARCH'",
                      },
                    ],
                    attrs: { type: "primary", size: "small" },
                    on: { click: _vm.handleSearch },
                  },
                  [_vm._v("搜索")]
                ),
                _vm.currentTab === "local"
                  ? _c(
                      "el-button",
                      {
                        directives: [
                          {
                            name: "auth",
                            rawName: "v-auth",
                            value: "SCREEN_CHARGE_MANAGE_ADD",
                            expression: "'SCREEN_CHARGE_MANAGE_ADD'",
                          },
                        ],
                        attrs: { type: "primary", size: "small" },
                        on: { click: _vm.handleAdd },
                      },
                      [_vm._v("新增")]
                    )
                  : _vm._e(),
              ],
              1
            ),
          ]),
          _c(
            "el-table",
            {
              key: _vm.currentTab,
              staticStyle: { width: "100%", "margin-top": "10px" },
              attrs: { data: _vm.listData, border: "", "max-height": "650" },
            },
            [
              _c("el-table-column", {
                attrs: { prop: "id", width: "60", label: "ID" },
              }),
              _c("el-table-column", {
                attrs: {
                  prop: "name",
                  width: "150",
                  label: "策略名称",
                  "show-overflow-tooltip": "",
                },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (scope) {
                      return [
                        _c("span", [_vm._v(_vm._s(scope.row.name || "-"))]),
                      ]
                    },
                  },
                ]),
              }),
              _c("el-table-column", {
                attrs: {
                  prop: "receiveChannel",
                  width: "200",
                  label: "收端渠道",
                },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (scope) {
                      return [
                        _c("span", [
                          _vm._v(_vm._s(_vm.getReceiveChannel(scope.row))),
                        ]),
                      ]
                    },
                  },
                ]),
              }),
              _c("el-table-column", {
                attrs: { prop: "sendChannel", width: "200", label: "发端渠道" },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (scope) {
                      return [
                        _c("span", [
                          _vm._v(_vm._s(_vm.getSendChannel(scope.row))),
                        ]),
                      ]
                    },
                  },
                ]),
              }),
              _c("el-table-column", {
                attrs: { prop: "endType", label: "配置端", width: "100" },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (scope) {
                      return [
                        _c("span", [
                          _vm._v(
                            _vm._s(_vm.endTypeFormatter(scope.row.endType))
                          ),
                        ]),
                      ]
                    },
                  },
                ]),
              }),
              _c("el-table-column", {
                attrs: {
                  prop: "versionTargetType",
                  label: "版本目标类型",
                  width: "120",
                },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (scope) {
                      return [
                        _c("span", [
                          _vm._v(
                            _vm._s(
                              _vm.versionTargetTypeFormatter(
                                scope.row.versionTargetType
                              )
                            )
                          ),
                        ]),
                      ]
                    },
                  },
                ]),
              }),
              _c("el-table-column", {
                attrs: {
                  "show-overflow-tooltip": "",
                  prop: "tvVersion",
                  label: "版本号",
                  width: "200",
                },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (scope) {
                      return [
                        _c("span", [
                          _vm._v(
                            _vm._s(
                              _vm.tvVersionFormatter(
                                scope.row.tvVersionType,
                                scope.row.tvVersion
                              )
                            )
                          ),
                        ]),
                      ]
                    },
                  },
                ]),
              }),
              _c("el-table-column", {
                attrs: {
                  prop: "pushLimitLabel",
                  label: "推送限制",
                  width: "200",
                },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (scope) {
                      return [
                        _c(
                          "span",
                          { staticStyle: { "white-space": "pre-line" } },
                          [_vm._v(_vm._s(scope.row.pushLimitLabel || "-"))]
                        ),
                      ]
                    },
                  },
                ]),
              }),
              _c("el-table-column", {
                attrs: {
                  prop: "lanMirrorLimitLabel",
                  label: "局域网镜像限制",
                  width: "200",
                },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (scope) {
                      return [
                        _c(
                          "span",
                          { staticStyle: { "white-space": "pre-line" } },
                          [_vm._v(_vm._s(scope.row.lanMirrorLimitLabel || "-"))]
                        ),
                      ]
                    },
                  },
                ]),
              }),
              _c("el-table-column", {
                attrs: {
                  prop: "cloudMirrorLimitLabel",
                  label: "云镜像限制",
                  width: "200",
                },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (scope) {
                      return [
                        _c(
                          "span",
                          { staticStyle: { "white-space": "pre-line" } },
                          [
                            _vm._v(
                              _vm._s(scope.row.cloudMirrorLimitLabel || "-")
                            ),
                          ]
                        ),
                      ]
                    },
                  },
                ]),
              }),
              _c("el-table-column", {
                attrs: {
                  prop: "imagePushLimitLabel",
                  label: "图片推送限制",
                  width: "200",
                },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (scope) {
                      return [
                        _c(
                          "span",
                          { staticStyle: { "white-space": "pre-line" } },
                          [_vm._v(_vm._s(scope.row.imagePushLimitLabel || "-"))]
                        ),
                      ]
                    },
                  },
                ]),
              }),
              _c("el-table-column", {
                attrs: {
                  prop: "officeMeetingLimitLabel",
                  label: "办公开会限制",
                  width: "200",
                },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (scope) {
                      return [
                        _c(
                          "span",
                          { staticStyle: { "white-space": "pre-line" } },
                          [
                            _vm._v(
                              _vm._s(scope.row.officeMeetingLimitLabel || "-")
                            ),
                          ]
                        ),
                      ]
                    },
                  },
                ]),
              }),
              _c("el-table-column", {
                attrs: {
                  prop: "friendShareLimitLabel",
                  label: "好友邀请限制",
                  width: "200",
                },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (scope) {
                      return [
                        _c(
                          "span",
                          { staticStyle: { "white-space": "pre-line" } },
                          [
                            _vm._v(
                              _vm._s(scope.row.friendShareLimitLabel || "-")
                            ),
                          ]
                        ),
                      ]
                    },
                  },
                ]),
              }),
              _c("el-table-column", {
                attrs: { width: "80", prop: "statusLabel", label: "状态" },
              }),
              _vm.currentTab === "local"
                ? _c("el-table-column", {
                    attrs: {
                      prop: "reviewStatus",
                      label: "审核状态",
                      width: "80",
                    },
                    scopedSlots: _vm._u(
                      [
                        {
                          key: "default",
                          fn: function ({ row }) {
                            return [
                              row.reviewStatus == 1
                                ? _c("span", [_vm._v("草稿")])
                                : _vm._e(),
                              row.reviewStatus == 2
                                ? _c("span", [_vm._v("待审核")])
                                : _vm._e(),
                              row.reviewStatus == 3
                                ? _c("span", [_vm._v("通过")])
                                : _vm._e(),
                              row.reviewStatus == 4
                                ? _c("span", [_vm._v("未通过")])
                                : _vm._e(),
                            ]
                          },
                        },
                      ],
                      null,
                      false,
                      2534739382
                    ),
                  })
                : _vm._e(),
              _c("el-table-column", {
                attrs: {
                  "show-overflow-tooltip": "",
                  prop: "descr",
                  label: "备注",
                },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (scope) {
                      return [
                        _vm._v(
                          "\n          " +
                            _vm._s(scope.row.descr || "-") +
                            "\n        "
                        ),
                      ]
                    },
                  },
                ]),
              }),
              _vm.currentTab === "local"
                ? _c("el-table-column", {
                    attrs: { label: "操作", width: "200", fixed: "right" },
                    scopedSlots: _vm._u(
                      [
                        {
                          key: "default",
                          fn: function (scope) {
                            return [
                              scope.row.reviewStatus != 2
                                ? _c(
                                    "el-button",
                                    {
                                      directives: [
                                        {
                                          name: "auth",
                                          rawName: "v-auth",
                                          value: "SCREEN_CHARGE_MANAGE_EDIT",
                                          expression:
                                            "'SCREEN_CHARGE_MANAGE_EDIT'",
                                        },
                                      ],
                                      attrs: { type: "text", size: "small" },
                                      on: {
                                        click: function ($event) {
                                          return _vm.editEvent(scope.row)
                                        },
                                      },
                                    },
                                    [_vm._v("编辑")]
                                  )
                                : _vm._e(),
                              scope.row.reviewStatus == 1 ||
                              !scope.row.reviewStatus
                                ? _c(
                                    "el-button",
                                    {
                                      directives: [
                                        {
                                          name: "auth",
                                          rawName: "v-auth",
                                          value: "SCREEN_CHARGE_MANAGE_REVIEW",
                                          expression:
                                            "'SCREEN_CHARGE_MANAGE_REVIEW'",
                                        },
                                      ],
                                      attrs: { type: "text", size: "small" },
                                      on: {
                                        click: function ($event) {
                                          return _vm.submitAudit(scope.row.id)
                                        },
                                      },
                                    },
                                    [_vm._v("提交审核")]
                                  )
                                : _vm._e(),
                              scope.row.reviewStatus == 2
                                ? _c(
                                    "el-button",
                                    {
                                      directives: [
                                        {
                                          name: "auth",
                                          rawName: "v-auth",
                                          value:
                                            "SCREEN_CHARGE_MANAGE_REVOKE_REVIEW",
                                          expression:
                                            "'SCREEN_CHARGE_MANAGE_REVOKE_REVIEW'",
                                        },
                                      ],
                                      attrs: { type: "text", size: "small" },
                                      on: {
                                        click: function ($event) {
                                          return _vm.revokeAudit(scope.row.id)
                                        },
                                      },
                                    },
                                    [_vm._v("撤销审核")]
                                  )
                                : _vm._e(),
                              scope.row.reviewStatus != 2
                                ? _c(
                                    "el-button",
                                    {
                                      directives: [
                                        {
                                          name: "auth",
                                          rawName: "v-auth",
                                          value: "SCREEN_CHARGE_MANAGE_DEL",
                                          expression:
                                            "'SCREEN_CHARGE_MANAGE_DEL'",
                                        },
                                      ],
                                      attrs: { type: "text", size: "small" },
                                      on: {
                                        click: function ($event) {
                                          return _vm.delEvent(scope.row.id)
                                        },
                                      },
                                    },
                                    [_vm._v("删除")]
                                  )
                                : _vm._e(),
                              _c(
                                "el-button",
                                {
                                  directives: [
                                    {
                                      name: "auth",
                                      rawName: "v-auth",
                                      value: "SCREEN_CHARGE_MANAGE_LOG",
                                      expression: "'SCREEN_CHARGE_MANAGE_LOG'",
                                    },
                                  ],
                                  attrs: { type: "text", size: "small" },
                                  on: {
                                    click: function ($event) {
                                      return _vm.viewLog(scope.row)
                                    },
                                  },
                                },
                                [_vm._v("日志")]
                              ),
                            ]
                          },
                        },
                      ],
                      null,
                      false,
                      2277147590
                    ),
                  })
                : _vm._e(),
            ],
            1
          ),
          _c("ElementPagination", {
            staticStyle: { "margin-bottom": "20px" },
            attrs: {
              "current-page": _vm.searchParams.current,
              "page-size": _vm.searchParams.size,
              total: _vm.searchParams.total,
              "page-sizes": [10, 20, 30, 40, 50],
            },
            on: {
              "size-change": _vm.handleSizeChange,
              "current-change": _vm.handleCurrentChange,
            },
          }),
          _c("LogDialog", {
            ref: "optionLog",
            attrs: { columnConfig: _vm.optionLogColumn, closeBtn: false },
            on: { reload: _vm.reloadOpt },
            scopedSlots: _vm._u([
              {
                key: "type",
                fn: function ({ row }) {
                  return [
                    _c("div", [
                      row.type === 1 ? _c("span", [_vm._v("新增")]) : _vm._e(),
                      row.type === 2 ? _c("span", [_vm._v("修改")]) : _vm._e(),
                      row.type === 3 ? _c("span", [_vm._v("删除")]) : _vm._e(),
                      row.type === 4
                        ? _c("span", [_vm._v("提交审核")])
                        : _vm._e(),
                      row.type === 5
                        ? _c("span", [_vm._v("撤销审核")])
                        : _vm._e(),
                      row.type === 6
                        ? _c("span", [_vm._v("审核通过")])
                        : _vm._e(),
                      row.type === 7
                        ? _c("span", [_vm._v("审核拒绝")])
                        : _vm._e(),
                    ]),
                  ]
                },
              },
            ]),
          }),
        ],
        1
      ),
      _c(
        "el-dialog",
        {
          attrs: {
            title: _vm.isEdit ? "编辑策略" : "新增策略",
            "append-to-body": "",
            visible: _vm.addDialog,
            width: "45%",
          },
          on: {
            "update:visible": function ($event) {
              _vm.addDialog = $event
            },
            close: _vm.closeDialog,
            open: _vm.beforeOpenDialog,
          },
        },
        [
          _c(
            "el-form",
            {
              ref: "addForm",
              attrs: {
                "label-width": "135px",
                model: _vm.addForm,
                rules: _vm.rules,
              },
            },
            [
              _c(
                "el-form-item",
                { attrs: { label: "策略名称", prop: "name" } },
                [
                  _c("el-input", {
                    staticStyle: { width: "70%" },
                    attrs: { placeholder: "请输入策略名称" },
                    model: {
                      value: _vm.addForm.name,
                      callback: function ($$v) {
                        _vm.$set(_vm.addForm, "name", $$v)
                      },
                      expression: "addForm.name",
                    },
                  }),
                ],
                1
              ),
              _c(
                "el-form-item",
                { attrs: { label: "配置端", prop: "endType" } },
                [
                  _c(
                    "el-radio-group",
                    {
                      on: { change: _vm.handleEndTypeChange },
                      model: {
                        value: _vm.addForm.endType,
                        callback: function ($$v) {
                          _vm.$set(_vm.addForm, "endType", $$v)
                        },
                        expression: "addForm.endType",
                      },
                    },
                    _vm._l(_vm.endTypeOptions, function (opt) {
                      return _c(
                        "el-radio",
                        { key: opt.value, attrs: { label: opt.value } },
                        [_vm._v(_vm._s(opt.label))]
                      )
                    }),
                    1
                  ),
                  _c("div", { staticClass: "form-tip" }, [
                    _vm._v(
                      '\n          收端：给接收端（APK/TV）的收费降级策略；发端：给发送端（APP）的收费降级策略。\n          下方"收端渠道选择"与"发端渠道选择"是两个独立入口，分别填写接收端（APK/TV）与发送端（APP）的 appId，互不复用。\n          除"好友邀请"外，其余权益的策略匹配需两端条件同时满足；"好友邀请"仅按发端渠道匹配，不看收端渠道与版本号。\n        '
                    ),
                  ]),
                ],
                1
              ),
              _c(
                "el-form-item",
                { attrs: { label: "收端渠道选择", prop: "channelType" } },
                [
                  _c(
                    "el-radio-group",
                    {
                      model: {
                        value: _vm.addForm.channelType,
                        callback: function ($$v) {
                          _vm.$set(_vm.addForm, "channelType", $$v)
                        },
                        expression: "addForm.channelType",
                      },
                    },
                    [
                      _c("el-radio", { attrs: { label: 2 } }, [
                        _vm._v("全部渠道"),
                      ]),
                      _c("el-radio", { attrs: { label: 1 } }, [
                        _vm._v("指定渠道"),
                      ]),
                    ],
                    1
                  ),
                ],
                1
              ),
              _vm.addForm.channelType === 1
                ? _c(
                    "el-form-item",
                    { attrs: { prop: "receiveChannel" } },
                    [
                      _c("el-input", {
                        staticStyle: { width: "70%" },
                        attrs: {
                          autosize: { minRows: 4, maxRows: 10000 },
                          type: "textarea",
                        },
                        on: { focus: _vm.goSelectChannel },
                        model: {
                          value: _vm.addForm.receiveChannel,
                          callback: function ($$v) {
                            _vm.$set(_vm.addForm, "receiveChannel", $$v)
                          },
                          expression: "addForm.receiveChannel",
                        },
                      }),
                    ],
                    1
                  )
                : _vm._e(),
              _c(
                "el-form-item",
                { attrs: { label: "发端渠道选择", prop: "sendChannelType" } },
                [
                  _c(
                    "el-radio-group",
                    {
                      model: {
                        value: _vm.addForm.sendChannelType,
                        callback: function ($$v) {
                          _vm.$set(_vm.addForm, "sendChannelType", $$v)
                        },
                        expression: "addForm.sendChannelType",
                      },
                    },
                    [
                      _c("el-radio", { attrs: { label: 2 } }, [
                        _vm._v("全部渠道"),
                      ]),
                      _c("el-radio", { attrs: { label: 1 } }, [
                        _vm._v("指定渠道"),
                      ]),
                    ],
                    1
                  ),
                ],
                1
              ),
              _vm.addForm.sendChannelType === 1
                ? _c(
                    "el-form-item",
                    { attrs: { prop: "sendChannel" } },
                    [
                      _c("el-input", {
                        staticStyle: { width: "70%" },
                        attrs: {
                          autosize: { minRows: 4, maxRows: 10000 },
                          type: "textarea",
                        },
                        on: { focus: _vm.goSelectSendChannel },
                        model: {
                          value: _vm.addForm.sendChannel,
                          callback: function ($$v) {
                            _vm.$set(_vm.addForm, "sendChannel", $$v)
                          },
                          expression: "addForm.sendChannel",
                        },
                      }),
                    ],
                    1
                  )
                : _vm._e(),
              _c(
                "el-form-item",
                { attrs: { label: "版本", prop: "versionTargetType" } },
                [
                  _c(
                    "el-radio-group",
                    {
                      on: { change: _vm.handleVersionTargetTypeChange },
                      model: {
                        value: _vm.addForm.versionTargetType,
                        callback: function ($$v) {
                          _vm.$set(_vm.addForm, "versionTargetType", $$v)
                        },
                        expression: "addForm.versionTargetType",
                      },
                    },
                    _vm._l(_vm.versionTargetTypeOptions, function (opt) {
                      return _c(
                        "el-radio",
                        { key: opt.value, attrs: { label: opt.value } },
                        [_vm._v(_vm._s(opt.label))]
                      )
                    }),
                    1
                  ),
                ],
                1
              ),
              _c(
                "el-form-item",
                {
                  attrs: {
                    label: _vm.versionFieldLabel,
                    prop: "tvVersionType",
                  },
                },
                [
                  _c(
                    "el-radio-group",
                    {
                      model: {
                        value: _vm.addForm.tvVersionType,
                        callback: function ($$v) {
                          _vm.$set(_vm.addForm, "tvVersionType", $$v)
                        },
                        expression: "addForm.tvVersionType",
                      },
                    },
                    [
                      _c("el-radio", { attrs: { label: 1 } }, [
                        _vm._v("全部版本"),
                      ]),
                      _c("el-radio", { attrs: { label: 2 } }, [
                        _vm._v("版本区间"),
                      ]),
                      _c("el-radio", { attrs: { label: 3 } }, [
                        _vm._v("指定版本"),
                      ]),
                    ],
                    1
                  ),
                ],
                1
              ),
              _vm.addForm.tvVersionType === 2
                ? [
                    _c(
                      "div",
                      { staticClass: "tv-version-input" },
                      [
                        _c(
                          "el-form-item",
                          {
                            attrs: {
                              prop: "tvVersionMin",
                              label: "最小版本号（>=）",
                            },
                          },
                          [
                            _c("el-input", {
                              staticStyle: {
                                width: "120px",
                                "margin-right": "10px",
                              },
                              attrs: { size: "small" },
                              model: {
                                value: _vm.addForm.tvVersionMin,
                                callback: function ($$v) {
                                  _vm.$set(_vm.addForm, "tvVersionMin", $$v)
                                },
                                expression: "addForm.tvVersionMin",
                              },
                            }),
                          ],
                          1
                        ),
                        _c(
                          "el-form-item",
                          {
                            attrs: {
                              prop: "tvVersionMax",
                              label: "最大版本号（<=）",
                            },
                          },
                          [
                            _c("el-input", {
                              staticStyle: { width: "120px" },
                              attrs: { size: "small" },
                              model: {
                                value: _vm.addForm.tvVersionMax,
                                callback: function ($$v) {
                                  _vm.$set(_vm.addForm, "tvVersionMax", $$v)
                                },
                                expression: "addForm.tvVersionMax",
                              },
                            }),
                          ],
                          1
                        ),
                      ],
                      1
                    ),
                  ]
                : _vm.addForm.tvVersionType === 3
                ? [
                    _c(
                      "el-form-item",
                      { attrs: { prop: "tvVersionSpecified" } },
                      [
                        _c("el-input", {
                          staticStyle: { width: "70%" },
                          attrs: {
                            type: "textarea",
                            placeholder: "请输入指定版本号，多个用英文逗号隔开",
                          },
                          model: {
                            value: _vm.addForm.tvVersionSpecified,
                            callback: function ($$v) {
                              _vm.$set(_vm.addForm, "tvVersionSpecified", $$v)
                            },
                            expression: "addForm.tvVersionSpecified",
                          },
                        }),
                      ],
                      1
                    ),
                  ]
                : _vm._e(),
              _c(
                "el-form-item",
                {
                  attrs: {
                    label: "权益配置",
                    prop: "rightConfigGroup",
                    required: "",
                  },
                },
                [
                  _c(
                    "el-checkbox-group",
                    {
                      model: {
                        value: _vm.addForm.rightConfigGroup,
                        callback: function ($$v) {
                          _vm.$set(_vm.addForm, "rightConfigGroup", $$v)
                        },
                        expression: "addForm.rightConfigGroup",
                      },
                    },
                    [
                      _c("el-checkbox", { attrs: { label: "1" } }, [
                        _vm._v("视频推送"),
                      ]),
                      _c("el-checkbox", { attrs: { label: "2" } }, [
                        _vm._v("局域网镜像"),
                      ]),
                      _c("el-checkbox", { attrs: { label: "3" } }, [
                        _vm._v("云镜像"),
                      ]),
                      _c("el-checkbox", { attrs: { label: "4" } }, [
                        _vm._v("图片推送"),
                      ]),
                      _c("el-checkbox", { attrs: { label: "5" } }, [
                        _vm._v("办公开会"),
                      ]),
                      _vm.showFriendShareRight
                        ? _c("el-checkbox", { attrs: { label: "6" } }, [
                            _vm._v("好友邀请"),
                          ])
                        : _vm._e(),
                    ],
                    1
                  ),
                ],
                1
              ),
              _c("PushForm", {
                directives: [
                  {
                    name: "show",
                    rawName: "v-show",
                    value: _vm.addForm.rightConfigGroup.includes("1"),
                    expression: "addForm.rightConfigGroup.includes('1')",
                  },
                ],
                ref: "pushForm",
                on: {
                  "mode-change": function ($event) {
                    return _vm.handleDegradeModeChange("1", $event)
                  },
                },
              }),
              _c("mirror-config", {
                directives: [
                  {
                    name: "show",
                    rawName: "v-show",
                    value: _vm.addForm.rightConfigGroup.includes("2"),
                    expression: "addForm.rightConfigGroup.includes('2')",
                  },
                ],
                ref: "lanMirrorConfig",
                attrs: {
                  title: "局域网镜像",
                  "degrade-config-type": "lanMirror",
                },
                on: {
                  "mode-change": function ($event) {
                    return _vm.handleDegradeModeChange("2", $event)
                  },
                },
              }),
              _c("mirror-config", {
                directives: [
                  {
                    name: "show",
                    rawName: "v-show",
                    value: _vm.addForm.rightConfigGroup.includes("3"),
                    expression: "addForm.rightConfigGroup.includes('3')",
                  },
                ],
                ref: "cloudMirrorConfig",
                attrs: {
                  title: "云镜像",
                  "degrade-config-type": "cloudMirror",
                },
                on: {
                  "mode-change": function ($event) {
                    return _vm.handleDegradeModeChange("3", $event)
                  },
                },
              }),
              _c("mirror-config", {
                directives: [
                  {
                    name: "show",
                    rawName: "v-show",
                    value: _vm.addForm.rightConfigGroup.includes("4"),
                    expression: "addForm.rightConfigGroup.includes('4')",
                  },
                ],
                ref: "imageMirrorConfig",
                attrs: {
                  title: "图片",
                  "default-mode": 2,
                  "mode1-disabled": true,
                  "degrade-config-type": "image",
                },
                on: {
                  "mode-change": function ($event) {
                    return _vm.handleDegradeModeChange("4", $event)
                  },
                },
              }),
              _c("mirror-config", {
                directives: [
                  {
                    name: "show",
                    rawName: "v-show",
                    value: _vm.addForm.rightConfigGroup.includes("5"),
                    expression: "addForm.rightConfigGroup.includes('5')",
                  },
                ],
                ref: "officeMirrorConfig",
                attrs: {
                  title: "办公开会",
                  "default-mode": 2,
                  "mode1-disabled": true,
                  "degrade-config-type": "officeMeeting",
                },
                on: {
                  "mode-change": function ($event) {
                    return _vm.handleDegradeModeChange("5", $event)
                  },
                },
              }),
              _c(
                "div",
                {
                  directives: [
                    {
                      name: "show",
                      rawName: "v-show",
                      value: _vm.showFriendShareConfig,
                      expression: "showFriendShareConfig",
                    },
                  ],
                  staticClass: "friend-share-config",
                },
                [
                  _c("div", { staticClass: "friend-share-config__title" }, [
                    _vm._v("好友邀请"),
                  ]),
                  _c("div", { staticClass: "form-tip" }, [
                    _vm._v(
                      '\n          仅支持"方式3 服务降级"；适用渠道请填上方"发端渠道选择"，不受收端渠道与版本号影响\n        '
                    ),
                  ]),
                  _c("DegradeConfig", {
                    ref: "friendShareDegradeConfig",
                    attrs: { "config-type": "friendShare" },
                  }),
                ],
                1
              ),
              _vm.hasDegradeMode3
                ? _c(
                    "el-form-item",
                    {
                      attrs: {
                        label: "每天可用高清时长",
                        prop: "strategyDayTime",
                      },
                    },
                    [
                      _c("el-input", {
                        staticStyle: { width: "200px" },
                        attrs: { placeholder: "请输入秒数" },
                        model: {
                          value: _vm.addForm.strategyDayTime,
                          callback: function ($$v) {
                            _vm.$set(_vm.addForm, "strategyDayTime", $$v)
                          },
                          expression: "addForm.strategyDayTime",
                        },
                      }),
                      _c(
                        "span",
                        {
                          staticClass: "form-tip",
                          staticStyle: {
                            display: "inline",
                            "margin-left": "8px",
                          },
                        },
                        [_vm._v("秒（所有服务降级方式3权益共用）")]
                      ),
                    ],
                    1
                  )
                : _vm._e(),
              _c(
                "el-form-item",
                {
                  staticStyle: { "margin-top": "10px" },
                  attrs: { label: "备注" },
                },
                [
                  _c("el-input", {
                    staticStyle: { width: "70%" },
                    attrs: {
                      type: "textarea",
                      autosize: { minRows: 4, maxRows: 10000 },
                      maxlength: "9999",
                    },
                    model: {
                      value: _vm.addForm.descr,
                      callback: function ($$v) {
                        _vm.$set(_vm.addForm, "descr", $$v)
                      },
                      expression: "addForm.descr",
                    },
                  }),
                ],
                1
              ),
              _c(
                "el-form-item",
                { attrs: { label: "状态", prop: "status" } },
                [
                  _c(
                    "el-radio-group",
                    {
                      model: {
                        value: _vm.addForm.status,
                        callback: function ($$v) {
                          _vm.$set(_vm.addForm, "status", $$v)
                        },
                        expression: "addForm.status",
                      },
                    },
                    [
                      _c("el-radio", { attrs: { label: "1" } }, [
                        _vm._v("启用"),
                      ]),
                      _c("el-radio", { attrs: { label: "0" } }, [
                        _vm._v("禁用"),
                      ]),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            2
          ),
          _c(
            "span",
            { attrs: { slot: "footer" }, slot: "footer" },
            [
              _c("el-button", { on: { click: _vm.closeDialog } }, [
                _vm._v("取 消"),
              ]),
              _c(
                "el-button",
                { attrs: { type: "primary" }, on: { click: _vm.confirmAdd } },
                [_vm._v("确 定")]
              ),
            ],
            1
          ),
        ],
        1
      ),
      _c("channel-popups", {
        attrs: {
          appId: _vm.tempAppId,
          visible: _vm.selectDialog,
          terminalType: _vm.terminalType,
          vipTypeFilter: _vm.channelVipTypeFilter,
        },
        on: {
          "update:visible": function ($event) {
            _vm.selectDialog = $event
          },
          "update:terminalType": function ($event) {
            _vm.terminalType = $event
          },
          "update:terminal-type": function ($event) {
            _vm.terminalType = $event
          },
          comfirm: _vm.handleSelectConfirm,
        },
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }